import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, collection, query as queryFire, where, getDocs, updateDoc, doc } from "firebase/firestore";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const firestore = getFirestore();

function EditMaterial() {
    let { id } = useParams();

    const [state, setState] = useState({
        id: id,
        name: '',
        codigos: '',
        description: '',
        visible: true,
        submitted: false,
    });

    useEffect(() => {
        getMaterialOnce();
    }, []);

    const getMaterialOnce = async () => {
        try {
            const materialesCollectionRef = collection(firestore, 'materiales');
            const q = queryFire(materialesCollectionRef, where('id', '==', parseInt(state.id, 10)));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                querySnapshot.forEach((docSnap) => {
                    const data = docSnap.data();
                    setState(prev => ({ ...prev, ...data, visible: data.visible !== false }));
                });
            } else {
                console.log("No se encontró el material.");
            }
        } catch (error) {
            console.error("Error al obtener el material:", error);
        }
    };

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const updateMaterial = async () => {
        try {
            const data = {
                name: state.name,
                codigos: state.codigos,
                description: state.description,
                visible: state.visible !== false,
            };
            const docRef = doc(firestore, "materiales", String(state.id));

            await updateDoc(docRef, data);

            console.log("Material actualizado exitosamente");
            setState({ ...state, submitted: true });
        } catch (error) {
            console.error("Error al actualizar el material: ", error);
        }
    };

    return (
        <Container component="main" maxWidth="md">
            {state.submitted ? (
                <div>
                    <Typography variant="h4">Material editado correctamente!</Typography>
                    <Button href="/materiales"> Ir a listado </Button>
                </div>
            ) : (
                <div className="form-container">
                    <Typography component="h1" variant="h5">
                        Editar Material
                    </Typography>
                    <div className="order-container">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    className="default__textfield"
                                    id="name"
                                    label="Nombre"
                                    value={state.name}
                                    name="name"
                                    onChange={onChangeValues}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    className="default__textfield"
                                    id="codigos"
                                    label="Códigos (separados por coma)"
                                    value={state.codigos}
                                    name="codigos"
                                    onChange={onChangeValues}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    className="default__textfield"
                                    id="description"
                                    label="Descripción"
                                    value={state.description}
                                    name="description"
                                    onChange={onChangeValues}
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={state.visible !== false}
                                            onChange={(e) => setState(prev => ({ ...prev, visible: e.target.checked }))}
                                            color="primary"
                                        />
                                    }
                                    label="Visible"
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="button__save"
                            onClick={updateMaterial}
                        >
                            Aceptar
                        </Button>
                    </div>
                </div>
            )}
        </Container>
    );
}

export default EditMaterial;
